/** "Join code · PINs": what a facilitator reads out to start the day. A seat PIN is shown once when it is given, so the card says where to give one. */
import { Link } from "../shell/history";
import { GxCard } from "../theme/primitives";

export function JoinCard({ cohortId, joinCode }: { readonly cohortId: string; readonly joinCode: string | null }) {
  if (joinCode === null) return null;
  const where = `${globalThis.location?.origin ?? ""}/join`;
  return (
    <GxCard title="Join code · PINs" className="gx-fac-join" testId="board.join">
      <div className="gx-card-b">
        <p>Players go to <b>{where}</b> and type the code <b className="gx-fac-code gx-num" data-testid="join.code">{joinCode}</b>.</p>
        <p className="gx-small gx-muted">Each CEO and risk officer gets a four-digit seat PIN when they take the seat. A PIN is shown once; if a team loses theirs, give a new one on the <Link href={`/f/${cohortId}/roster`}>Roster</Link>.</p>
      </div>
    </GxCard>
  );
}
